import { useMemo } from "react";
import { Card, Descriptions, Avatar } from "antd";
import { useUserInfo } from "@/hooks/user";
import { UserStatus, UserRole } from "@/constants/common";
import dayjs from "dayjs";
import _ from "lodash";

import DefaultAvatar from "@/assets/default-avatar.png";

export default function Home() {
  // 用户信息
  const { userInfo } = useUserInfo();
  // 配置项
  const items: any  = useMemo(() => userInfo ? [
    {
      label: '用户ID',
      key: 'id',
      children: userInfo?.id,
    },
    {
      label: '用户名',
      key: 'username',
      children: userInfo?.username,
    },
    {
      label: '头像',
      key: 'headimgurl',
      children: <Avatar src={userInfo?.headimgurl || DefaultAvatar} />,
    },
    {
      label: '手机号',
      key: 'nickname',
      children: userInfo?.mobile,
    },
    {
      label: '昵称',
      key: 'nickname',
      children: userInfo?.nickname,
    },
    {
      label: '角色',
      key: 'role',
      children: _.find(UserRole, { value: userInfo?.role })?.label,
    },
    {
      label: '状态',
      key: 'user_status',
      children: _.find(UserStatus, { value: userInfo?.user_status })?.label,
    },
    {
      label: '密码',
      key: 'new_password',
      children: userInfo?.new_password ? '已设置' : '未设置',
    },
    {
      label: 'IP',
      key: 'ip',
      children: userInfo?.ip,
    },
    {
      label: '注册时间',
      key: 'reg_time',
      children: dayjs(new Date(userInfo?.reg_time * 1000)).format("YYYY-MM-DD HH:mm:ss"),
    },
    {
      label: '最近登录时间',
      key: 'last_login_time',
      children: userInfo?.last_login_time,
    },
  ] : [], [userInfo]);

  return (
    <div className="">
      <Card hoverable={true} style={{ borderRadius: "8px" }}>
        <Descriptions title="用户信息" bordered items={items} />
      </Card>
    </div>
  )
}